require('./brokerMarketsCalendarDatePicker.scss');
const PropTypes = require('prop-types');
const React = require('react');
const BrokerMarketsCalendarDatePickerButton = require('components/broker/brokerMarketsCalendarDatePicker/brokerMarketsCalendarDatePickerButton');
const { DATE_PICKER_CUSTOM_LOCALE } = require('constants/commonsComponents');
const moment = require('moment');
const { DATE_FORMAT_DAY_TEXT_SHORT } = require('constants/index');
const { cleanUpAccents } = require('utilities/stringHelper');

class BrokerMarketsCalendarDatePicker extends React.Component {
    constructor(props) {
        super(props);
        this.handleButtonCallback = this.handleButtonCallback.bind(this);
    }

    buildCalendarWeek(daysOfWeek, dateSelected) {
        return daysOfWeek.map((dayOfWeek, index) => {
            const isActive = dayOfWeek.date === dateSelected;

            return (
                <td key={index} className="broker-markets-calendar-date-picker__col-number">
                    <BrokerMarketsCalendarDatePickerButton
                        index={index}
                        date={dayOfWeek.date}
                        isActive={isActive}
                        onStateChange={this.handleButtonCallback}
                    >
                        {dayOfWeek.day}
                    </BrokerMarketsCalendarDatePickerButton>
                </td>
            );
        });
    }

    /**
     * Returns name's week in short form
     * @return {Object}
     */
    buildTableHead() {
        return [0, 1, 2, 3, 4, 5, 6].map(index => {
            const formatDate = moment()
                               .locale(DATE_PICKER_CUSTOM_LOCALE)
                               .weekday(index)
                               .format(DATE_FORMAT_DAY_TEXT_SHORT)
                               .replace('.', '');
            const day = cleanUpAccents(formatDate);
            return (
                <th key={index} className="broker-markets-calendar-date-picker__col-title">{day}</th>
            );
        });
    }

    handleButtonCallback(buttonState) {
        this.props.onStateChange({
            'dateSelected': this.props.daysOfWeek[buttonState.index].date
        });
    }

    render() {
        const { daysOfWeek, dateSelected } = this.props;
        const columns = this.buildCalendarWeek(daysOfWeek, dateSelected);
        const tableHead = this.buildTableHead();

        return (
            <table className="broker-markets-calendar-date-picker">
                <thead>
                    <tr className="broker-markets-calendar-date-picker__row">
                        {tableHead}
                    </tr>
                </thead>
                <tbody>
                    <tr className="broker-markets-calendar-date-picker__row">
                        {columns}
                    </tr>
                </tbody>
            </table>
        );
    }
}

BrokerMarketsCalendarDatePicker.propTypes = {
    daysOfWeek: PropTypes.array,
    dateSelected: PropTypes.string,
    onStateChange: PropTypes.func,
}

BrokerMarketsCalendarDatePicker.defaultProps = {
    daysOfWeek: [],
    onStateChange: function(){},
}

module.exports = BrokerMarketsCalendarDatePicker;
